/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddMatch } from '../models/AddMatch';
import type { CloseMatch } from '../models/CloseMatch';
import type { Match } from '../models/Match';
import type { NewTournament } from '../models/NewTournament';
import type { PushNotificationRequest } from '../models/PushNotificationRequest';
import type { PushNotificationTestRequest } from '../models/PushNotificationTestRequest';
import type { Tournament } from '../models/Tournament';
import type { UpdateTournament } from '../models/UpdateTournament';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any Return value of AdminController.adminMigrateToTournaments
     * @throws ApiError
     */
    public adminControllerAdminMigrateToTournaments(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/add-tournaments',
        });
    }
    /**
     * @param requestBody
     * @returns any Award bonus question points to all users that picked the winning team.
     * @throws ApiError
     */
    public adminControllerAdminApplyBonusQuestion(
        requestBody?: {
            teamId: number;
        },
    ): CancelablePromise<{
        winningTeamId?: number;
        pointsAwarded?: number;
        usersAwarded?: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/bonus-question/apply',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any Return value of AdminController.adminDownloadTeamLogos
     * @throws ApiError
     */
    public adminControllerAdminDownloadTeamLogos(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/download-teamlogos',
        });
    }
    /**
     * @returns any Return value of AdminController.adminGetEvents
     * @throws ApiError
     */
    public adminControllerAdminGetEvents(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/import-events',
        });
    }
    /**
     * @returns any Return value of AdminController.adminGetTeams
     * @throws ApiError
     */
    public adminControllerAdminGetTeams(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/import-teams',
        });
    }
    /**
     * @param requestBody
     * @returns Match Retun new Match instance
     * @throws ApiError
     */
    public matchControllerAddMatch(
        requestBody?: AddMatch,
    ): CancelablePromise<Match> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/matches/add',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Return value of MatchController.closeMatch
     * @throws ApiError
     */
    public matchControllerCloseMatch(
        requestBody?: CloseMatch,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/matches/close',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any Rename sport value from football to soccer.
     * @throws ApiError
     */
    public adminControllerAdminMigrateFootballSportToSoccer(): CancelablePromise<{
        from?: string;
        to?: string;
        teamsUpdated?: number;
        tournamentsUpdated?: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/migrations/sport-football-to-soccer',
        });
    }
    /**
     * @returns any List of supported push notification types.
     * @throws ApiError
     */
    public userControllerGetNotificationTypes(): CancelablePromise<Array<{
        type?: string;
        name?: string;
        description?: string;
        dataExample?: Record<string, any>;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/notifications/types',
        });
    }
    /**
     * @returns any Return value of AdminController.adminPointsCorrection
     * @throws ApiError
     */
    public adminControllerAdminPointsCorrection(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/points/correction',
        });
    }
    /**
     * @returns any Return value of AdminController.adminSentTestEmail
     * @throws ApiError
     */
    public adminControllerAdminSentTestEmail(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/send-test-email',
        });
    }
    /**
     * @param requestBody Create new tournament
     * @returns Tournament Created Tournament model instance
     * @throws ApiError
     */
    public tournamentControllerAddTournament(
        requestBody?: NewTournament,
    ): CancelablePromise<Tournament> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/tournaments/add',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody Update tournament
     * @returns void
     * @throws ApiError
     */
    public tournamentControllerUpdateTournament(
        id: number,
        requestBody?: UpdateTournament,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/tournaments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public tournamentControllerDeleteTournament(
        id: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/tournaments/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any Push notification send result
     * @throws ApiError
     */
    public userControllerSendLogoutPushNotification(): CancelablePromise<{
        sent?: number;
        failed?: number;
        disabled?: number;
        errors?: Array<Record<string, any>>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/users/logout/push-notification',
        });
    }
    /**
     * @param requestBody
     * @returns any Push notification send result
     * @throws ApiError
     */
    public userControllerTestPushNotification(
        requestBody?: PushNotificationTestRequest,
    ): CancelablePromise<{
        sent?: number;
        failed?: number;
        disabled?: number;
        errors?: Array<Record<string, any>>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/users/push-notification',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns boolean
     * @throws ApiError
     */
    public userControllerSendReminderEmail(): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/users/send-reminder-emails',
        });
    }
    /**
     * @param id
     * @returns boolean Delete user account by admin
     * @throws ApiError
     */
    public userControllerAdminDeleteUserAccount(
        id: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/users/{id}/account',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns boolean Retun new Match instance
     * @throws ApiError
     */
    public userControllerPayEntryFee(
        id: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/users/{id}/pay-entry-fee',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any Push notification send result
     * @throws ApiError
     */
    public userControllerSendPushNotification(
        id: string,
        requestBody?: PushNotificationRequest,
    ): CancelablePromise<{
        sent?: number;
        failed?: number;
        disabled?: number;
        errors?: Array<Record<string, any>>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/users/{id}/push-notification',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns boolean Retun new Match instance
     * @throws ApiError
     */
    public userControllerSendPaymentInfo(
        id: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/users/{id}/send-payment-info',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any Return value of AdminController.adminListUsers
     * @throws ApiError
     */
    public adminControllerAdminListUsers(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/users',
        });
    }
}
